
<app-nav-home-student [linkId]="5" [learner]='learner' *ngIf="learner"></app-nav-home-student>

<div *ngIf="!loadingReport">
<div id="accordionSubjThemes" class="max-width" *ngIf="topics.length>0">
    <div class="text-center alert alert-info" *ngIf="renderMathNow" [appMath]="' Shows your current performance report.'"></div>
    <div class="card" *ngFor="let topic of topics; index as myCount">
      <div class="card-header" id="headingTheme{{topic.id}}">
       <div>
        <span>
        <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
            <i class="fa fa-square-o text-primary"></i>  <span > {{topic.name}}</span>
        </a>
       </span>
       <span class="pull-right">
        <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
            <app-star-rating [score]="topic.percentagePass"></app-star-rating>
        </a>
       </span>
    </div>
    </div>
    <div id="collapseTheme{{topic.id}}" class="collapse {{ myCount==0?'show':''}}" aria-labelledby="headingTheme{{topic.id}}" data-parent="#accordionSubjThemes">
        <div class="card-body">
            <app-performance-subtopic [topic]="topic" (renderMathRequest)="renderMathPage($event)"></app-performance-subtopic>
        </div>
      </div>
  </div>
  </div>
</div>
<app-spinner *ngIf="loadingReport"></app-spinner>
